// extracted by mini-css-extract-plugin
export default {"tag":"euCYBT","mobile":"vS_i3I"};